var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlerticon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 13.5009C11 14.0532 11.4477 14.5009 12 14.5009C12.5523 14.5009 13 14.0532 13 13.5009V10.5009C13 9.94857 12.5523 9.50085 12 9.50085C11.4477 9.50085 11 9.94857 11 10.5009V13.5009ZM13 16.4897C13 15.9374 12.5523 15.4897 12 15.4897C11.4477 15.4897 11 15.9374 11 16.4897V16.5009C11 17.0532 11.4477 17.5009 12 17.5009C12.5523 17.5009 13 17.0532 13 16.5009V16.4897ZM9.37735 5.16221C10.5204 3.10478 13.4793 3.10478 14.6223 5.16221L21.2233 17.044C22.3341 19.0436 20.8882 21.5009 18.6008 21.5009H5.39885C3.11139 21.5009 1.66549 19.0436 2.77637 17.044L9.37735 5.16221Z",
    fill: "#5F6D8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerticon);
export default __webpack_public_path__ + "static/media/alerticon.866e924c06e989b49aad8b046eda0dc3.svg";
export { ForwardRef as ReactComponent };